module.exports = "/virtual-football/img/video/video-bck.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/video-bck.png
// module id = 310
// module chunks = 6